import { CreatePostRequest, EditPostRequest } from '@/app/models/writing/WritingPosts';
import fetchWrapper from '../fetchWrapper';
import utilsService from '@/app/helpers/utilsService';
const BASE_URL = process.env.BASE_URL;

async function getGroup(signal?: AbortSignal): Promise<any> {
    try {
        const response = await fetchWrapper.get(`${BASE_URL}/groups`, { signal });
        return response;
    } catch (error: any) {
        throw error;
    }
}

async function getGroupPartner(id: string, signal?: AbortSignal): Promise<any> {
    try {
        const response = await fetchWrapper.get(`${BASE_URL}/partners/${id}/group`, { signal });
        return response;
    } catch (error: any) {
        throw error;
    }
}

async function writingPost(data: CreatePostRequest): Promise<any> {
    try {
        const response = await fetchWrapper.post(
            `${BASE_URL}/posts`,
            await utilsService.appendToFormData(data),
            { timeout: 300000 } // 5 minutes for large file uploads
        );
        return response;
    } catch (error: any) {
        throw error;
    }
}

async function updateFeedForOnlyPosts({ type = 'posts', id, data }: { type: string; id: string; data: EditPostRequest }): Promise<any> {
    try {
        const response = await fetchWrapper.post(
            `${BASE_URL}/${type}/${id}`,
            await utilsService.appendToFormData(data),
            { timeout: 300000 } // 5 minutes for large file uploads
        );
        return response;
    } catch (error) {
        throw error;
    }
}

export const writingService = {
    getGroup,
    getGroupPartner,
    writingPost,
    updateFeedForOnlyPosts,
};
